<mat-icon *ngIf="icon" class="notice__icon" [fontIcon]="icon"></mat-icon>
<span *ngIf="heading" class="notice__heading">{{ heading }}</span>
<div class="notice__body">
  <ng-content></ng-content>
</div>
